<template>
  <div>
    <!-- 已提交发票弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="发票信息"
      :visible.sync="invoiceVisible"
      :before-close="invoiceHandleClose"
      width="67.8%"
      center
      >
      <el-divider></el-divider>
      <div style="margin-bottom:20px">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="three"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="bill" label="账单号"></el-table-column>
          <el-table-column prop="addtime" label="业务周期"></el-table-column>
          <el-table-column prop="orderid" label="订单号"></el-table-column>
          <el-table-column prop="should_close" label="应结算金额(元)"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="billFn(scope.row)">账单明细</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fpContent">
        <div class="fpImg">
          <!-- <img src="@/images/scenic/fp.png" alt srcset /> -->
          <div>增值税发票</div>
          <el-form ref="form" :model="form" label-width="90px">
            <div class="fpForm">
              <el-form-item label="开票日期:">
                <span class="xingA">*</span>
                <el-date-picker v-model="form.invoice_date" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="发票代码:">
                <span class="xingA">*</span>
                <el-input v-model="form.invoice_code"></el-input>
              </el-form-item>
              <el-form-item label="发票号码:">
                <span class="xingA">*</span>
                <el-input v-model="form.invoice"></el-input>
                <div class="zhu">
                  <span>注:</span>
                  <span>尽量开增值专用发票</span>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="table1">
          <table class="table11">
            <tbody>
              <tr>
                <td class="Purchaser" rowspan="5">购买方</td>
                <td class="row2">账户名称(账户名称要与发票购买方一致)</td>
                <td class="row3">{{form.info_deploy.name}}</td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <td class="row2">纳税人识别号</td>
                <td class="row3">{{form.info_deploy.name}}</td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <td class="row2">地址以及电话</td>
                <td class="row3">{{form.info_deploy.site}} {{ form.info_deploy.phone}}</td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <td class="row2" rowspan="2">开户银行以及账号(如需要改打款账户,请点击按钮重新操作)</td>
                <td class="row3">{{form.info_deploy.bink_site}} </td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <!-- <td>开户银行以及账号(如需要改打款账户,请点击按钮重新操作)</td> -->
                <td class="row3">{{ form.info_deploy.account }}</td>
                <!-- <td>开户银行以及账号</td> -->
              </tr>
            </tbody>
          </table>
          <!-- <el-table
            :data="tableData1"
            :span-method="objectSpanMethodone"
            :show-header="false"
            border
            key="one"
            style="width: 100%"
          >
            <el-table-column prop="date" label="购买方" width="50"></el-table-column>
            <el-table-column prop="name" label="姓名" width="447"></el-table-column>
            <el-table-column prop="address" label="地址" width="760"></el-table-column>
          </el-table>-->
        </div>
        <div class="table2">
          <table class="table22">
            <tbody>
              <tr>
                <td class="Purchaser" rowspan="3">发票邮寄信息</td>
                <td class="row2">收件人姓名</td>
                <td class="row3">{{form.username}}</td>
              </tr>
              <tr>
                <!-- <td>发票邮寄信息</td> -->
                <td class="row2">收件人地址</td>
                <td class="row3">{{form.address}}</td>
              </tr>
              <tr>
                <!-- <td>发票邮寄信息</td> -->
                <td class="row2">收件人联系方式</td>
                <td class="row3">{{ form.expressphone }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <el-table
            :data="tableData2"
            :span-method="objectSpanMethodTwo"
            :show-header="false"
            border
            key="two"
            style="width: 100%"
          >
            <el-table-column prop="date" label="购买方" width="50"></el-table-column>
            <el-table-column prop="name" label="姓名" width="447"></el-table-column>
            <el-table-column prop="address" label="地址" width="760"></el-table-column>
          </el-table>-->
        </div>
        <div class="table3">
          <table class="table33">
            <tbody>
              <tr>
                <td class="Purchaser" rowspan="5">收款方</td>
                <td class="row2">账户名称(账户名称要与发票购买方一致)</td>
                <td class="row3">{{form.name}}</td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <td class="row2">联系人姓名</td>
                <td class="row3">{{form.couponname}}</td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <td class="row2">联系电话号</td>
                <td class="row3">{{form.phone}}</td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <td class="row2" rowspan="2">开户银行以及账号(如需要改打款账户,请点击按钮重新操作)</td>
                <td class="row3">
                  <span class="spanK">开户银行</span>
                  <input class="inputK" type="text" v-model="form.opening"/>
                </td>
              </tr>
              <tr>
                <!-- <td>购买方</td> -->
                <!-- <td>开户银行以及账号(如需要改打款账户,请点击按钮重新操作)</td> -->
                <td class="row3">
                  <span class="spanK">账号</span>
                  <input class="inputK" type="text" v-model="form.account" />
                </td>
                <!-- <td>开户银行以及账号</td> -->
              </tr>
            </tbody>
          </table>
          <!-- <el-table
            :data="tableData3"
            :span-method="objectSpanMethodone"
            :show-header="false"
            border
            key="three"
            style="width: 100%"
          >
            <el-table-column prop="date" label="购买方" width="50"></el-table-column>
            <el-table-column prop="name" label="姓名" width="447"></el-table-column>
            <el-table-column prop="address" label="地址" width="760"></el-table-column>
          </el-table>-->
        </div>
        <div class="formImg">
          <el-form ref="form" :model="form" label-width="110px">
            <el-form-item label="上传发票附件:">
              <span>*</span>
              <div class="formUrl">
                <img width="100%" :src="form.url" alt />
              </div>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button @click="examine('2')">驳回</el-button>
              <el-button class="btnL" @click="examine('1')">审核通过</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!-- 已提交发票弹框结束 -->
    <!-- 已提交查看详情开始 -->
    <!-- <el-dialog :close-on-click-modal="false"
      title="发票信息"
      :visible.sync="seeInfoVisible"
      :before-close="seeInfoHandleClose"
      width="67.8%"
      center
    >
      <el-divider></el-divider>
      <el-table
        :data="tableData1"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        key="two"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="name" label="业务时间"></el-table-column>
        <el-table-column prop="address" label="订单号"></el-table-column>
        <el-table-column prop="address" label="金额"></el-table-column>
      </el-table>
      <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
    </el-dialog> -->
    <!-- 已提交查看详情结束 -->
    <!-- 账单详情开始 -->
    <billDialog v-if="billvisible" ref="billDialog" :ids="ids" @billVisibleClose="billClose"></billDialog>
    <!-- 账单详情结束 -->
  </div>
</template>

<script>
import billDialog from "./billDialog.vue";
import {getInfoCloseInfo,invoiceCheck} from '@/request/distributor.js'

export default {
  props:['id'],
  components: {
    billDialog
  },
  data() {
    return {
      invoiceVisible: false, // 发票信息
      seeInfoVisible: false, // 查看详情
      billvisible: false, // 对账明细
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      form: {
      },
      tableData3: [
        {
          date: "收款方",
          name: "账户名称(账户名称要与发票购买方一致)",
          address: "账后名称"
        },
        {
          date: "收款方",
          name: "联系人姓名",
          address: "小花"
        },
        {
          date: "收款方",
          name: "联系人电话",
          address: "135897456"
        },
        {
          date: "收款方",
          name: "开户银行以及账号(如需要改打款账户,请点击按钮重新操作)",
          address: "开户银行号码"
        },
        {
          date: "收款方",
          name: "开户银行以及账号(如需要改打款账户,请点击按钮重新操作)",
          address: "开户银行号码"
        }
      ],
      tableData2: [
        {
          date: "发票邮寄信息",
          name: "收件人姓名",
          address: "小花"
        },
        {
          date: "发票邮寄信息",
          name: "收件人地址",
          address: "华远好天地"
        },
        {
          date: "发票邮寄信息",
          name: "收件人联系方式",
          address: "177568974"
        }
      ],
      tableData1: [
        {
          date: "购买方",
          name: "账户名称(账户名称要与发票购买方一致)",
          address: "账后名称"
        },
        {
          date: "购买方",
          name: "纳税人识别号",
          address: "纳税人识别号码"
        },
        {
          date: "购买方",
          name: "地址以及电话",
          address: "地址以及电话"
        },
        {
          date: "购买方",
          name: "开户银行",
          address: "开户银行号码"
        },
        {
          date: "购买方",
          name: "开户银行",
          address: "开户银行号码"
        }
      ],
      tableData: [
      ],
      ids:""
    };
  },
  created(){
    this.getDetail()
  },
  methods: {
    getDetail(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id : this.id
      }
      getInfoCloseInfo(data).then(res=>{
        if(res.data.status=='ok'){
            this.form = res.data.result
            if(res.data.result.infoCloseInfo){
              this.tableData.push(res.data.result.infoCloseInfo) 
            }
        }
      })
    },
    // 审核 驳回
    examine(state){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id : this.form.id,
        state: state
      }
      invoiceCheck(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
            this.$message.success('审核通过')
            this.invoiceVisible = false;
            this.$emit('close')
          }else{
             this.$message.error(res.data.msg);
          }
      })
    },
    // 账单明细
    billFn(row) {
      this.billvisible = true;
      this.ids  = row.id
      this.$nextTick(() => {
        this.$refs.billDialog.billDetail(row);
      });
    },
    billClose(){
      this.billvisible = false
    },
    // 发票信息
    invoice() {
      this.invoiceVisible = true;
    },
    // 发票信息X
    invoiceHandleClose() {
      this.invoiceVisible = false;
      this.$emit('close')
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.table2 {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #9d5117;
  border-radius: 4px;
  .table22 {
    width: 100%;
    height: 148px;
    .Purchaser {
      width: 50px;
      writing-mode: vertical-lr;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #9d5117;
      letter-spacing: 5px;
    }
    .row2 {
      padding-left: 10px;
      width: 450px;
      height: 50px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #9d5117;
    }
    .row3 {
      padding-left: 10px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
    tr td,
    th {
      border: 1px solid #9d5117;
    }
  }
}
.table1 {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #9d5117;
  border-radius: 4px;

  .table11 {
    width: 100%;
    height: 246px;
    .Purchaser {
      width: 50px;
      writing-mode: vertical-lr;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #9d5117;
      letter-spacing: 10px;
    }
    .row2 {
      padding-left: 10px;
      width: 450px;
      height: 50px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #9d5117;
    }
    .row3 {
      padding-left: 10px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
  tr td,
  th {
    border: 1px solid #9d5117;
  }
}
.table3 {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #9d5117;
  border-radius: 4px;

  .table33 {
    width: 100%;
    height: 246px;
    .spanK {
      width: 58px;
      text-align: right;
      display: inline-block;
      margin-right: 20px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
    .inputK {
      width: 360px;
      height: 30px;
      background: #f7f7fa;
      border-radius: 4px;
      outline: none;
      border: none;
      padding: 0 20px;
    }
    .Purchaser {
      width: 50px;
      writing-mode: vertical-lr;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #9d5117;
      letter-spacing: 10px;
    }
    .row2 {
      padding-left: 10px;
      width: 450px;
      height: 50px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #9d5117;
    }
    .row3 {
      padding-left: 10px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
  tr td,
  th {
    border: 1px solid #9d5117;
  }
}
.formImg {
  margin-top: 35px;
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #9d5117;
  }
  /deep/.el-form-item__content {
    line-height: 40px;
    position: relative;
    font-size: 14px;
    margin-top: 14px;
  }
  .el-form-item {
    position: relative;
  }
  span {
    position: absolute;
    top: -15px;
    left: -105px;
    color: #e74c3c;
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-left: -110px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
      margin-right: 20px;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
}
// .table1 {
//   margin-top: 20px;
//   // border: 1px solid #9d5117;
//   border-radius: 4px;
//   /deep/.el-table--border .el-table__cell:first-child .cell {
//     padding-left: 10px;
//     font-family: "OPPOSans";
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     color: #9d5117;
//   }
//   /deep/.el-table td.el-table__cell {
//     border-bottom: 1px solid #9d5117;
//   }
//   /deep/.el-table--border .el-table__cell {
//     border-right: 1px solid #9d5117;
//   }
// }
// .table2 {
//   margin-top: 20px;
//   border: 1px solid #9d5117;
//   border-radius: 4px;
//   /deep/.el-table--border .el-table__cell:first-child .cell {
//     padding-left: 10px;
//     font-family: "OPPOSans";
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     color: #9d5117;
//   }
//   /deep/.el-table td.el-table__cell {
//     border-bottom: 1px solid #9d5117;
//   }
//   /deep/.el-table--border .el-table__cell {
//     border-right: 1px solid #9d5117;
//   }
// }
// .table3 {
//   margin-top: 20px;
//   border: 1px solid #9d5117;
//   border-radius: 4px;
//   /deep/.el-table--border .el-table__cell:first-child .cell {
//     padding-left: 10px;
//     font-family: "OPPOSans";
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     color: #9d5117;
//   }
//   /deep/.el-table td.el-table__cell {
//     border-bottom: 1px solid #9d5117;
//   }
//   /deep/.el-table--border .el-table__cell {
//     border-right: 1px solid #9d5117;
//   }
// }
/deep/ .el-table__body tr:hover > td {
  background-color: white !important;
}

.fpContent {
  .fpImg {
    width: 1260px;
    height: 199px;
    background: url("../../../../images/scenic/fp.png");
    background-size: 100%;
    position: relative;
    border: 1px solid #9d5117;
    border-bottom: 2px solid #9d5117;
    border-radius: 4px;
    > div:nth-child(1) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 60px;
      text-align: center;
      color: #9d5117;
    }
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #e74c3c;
  }
  .fpForm {
    position: absolute;
    top: 115px;
    left: 50px;
    display: flex;
    .zhu {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      text-align: right;
      color: #9d5117;
    }
    /deep/.el-form-item__label {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #bb875f;
    }
    .el-date-picker {
      width: 263px;
    }
    .el-input {
      width: 300px;
    }
    /deep/.el-select .el-input.is-focus .el-input__inner {
      border-color: #bb875f;
    }
    /deep/.el-input .el-input--suffix {
      border-color: #bb875f;
    }
    /deep/.el-input__inner {
      -webkit-appearance: none;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #bb875f;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
  }
}

.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-form-item__label {
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: right;
  color: #666666;
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-table_3_column_15 .cell {
  color: #9d5117 !important;
}
/deep/.el-table_4_column_18 .cell {
  color: #9d5117 !important;
}
/deep/.el-table_5_column_21 .cell {
  color: #9d5117 !important;
}
/deep/.el-table_3_column_16 .cell {
  color: #606266 !important;
}
/deep/.el-table_5_column_22 .cell {
  color: #606266 !important;
}
.formUrl{
  width: 20rem;
  height: 14.1rem;
}
.formUrl img{
  width: 100%;
  height: 100%;
}
</style>